module.exports = __webpack_public_path__ + "img/image3.f3588b05.jpg";